import meta from "./meta";
import ga4 from "./ga4";
import googleAds from "./googleAds";

// Keys match `provider` in checkoutPage.tracking.pixels. A new provider is one adapter + one line here.
const providers = {
  meta,
  ga4,
  google_ads: googleAds,
};

export default providers;
